import { defineMessages } from 'react-intl';

import { AlreadyExistError, NotFoundError } from '@/shared/config';
import { UserBadRequestError } from '@/shared/config';

export const sharePatientErrorMessages = defineMessages<string>({
  [AlreadyExistError.ACCEPTED_PATIENT_SHARING]: {
    id: 'sharePatient.errors.alreadyRegisteredError',
    defaultMessage:
      "The patient's case has already been sent to this dental professional.",
  },
  [AlreadyExistError.INVITATION_TO_THIS_PATIENT]: {
    id: 'sharePatient.errors.alreadyRegisteredError',
    defaultMessage:
      "The patient's case has already been sent to this dental professional.",
  },
});

export const confirmEmailErrorMessages = defineMessages<string>({
  [UserBadRequestError.ALREADY_REGISTERED]: {
    id: 'confirmEmail.errors.alreadyRegisteredError',
    defaultMessage: 'You have already finished the registration',
  },
  [UserBadRequestError.CODE_RETRIES_LIMIT]: {
    id: 'confirmEmail.errors.retriesLimitError',
    defaultMessage:
      'The limit for retries has been exceeded for your confirmation code. Please refill the Sign Up form.',
  },
  [UserBadRequestError.CODE_IS_EXPIRED]: {
    id: 'confirmEmail.errors.codeExpiredError',
    defaultMessage:
      'The confirmation code has expired. Please refill your Sign Up form.',
  },
  [UserBadRequestError.SIGN_UP_HAS_EXPIRED]: {
    id: 'confirmEmail.errors.signUpHasExpiredError',
    defaultMessage:
      'This link is no longer valid. Please refill your Sign Up form.',
  },
  [UserBadRequestError.WRONG_CODE]: {
    id: 'confirmEmail.errors.wrongCodeError',
    defaultMessage: 'The code you have entered is incorrect. Please try again.',
  },
});

export const passwordErrorMessages = defineMessages<string>({
  [UserBadRequestError.PASSWORD_TOO_SHORT]: {
    id: 'passwordErrors.tooShort',
    defaultMessage: 'Password must be at least {minLength} characters long.',
  },
  [UserBadRequestError.PASSWORD_TOO_LONG]: {
    id: 'passwordErrors.tooLong',
    defaultMessage: 'Password must be at most {maxLength} characters long.',
  },
  [UserBadRequestError.PASSWORD_TOO_COMMON]: {
    id: 'passwordErrors.tooCommon',
    defaultMessage:
      'This password is too common and easy to guess. Please choose a different one.',
  },
});

export const signInErrorMessages = defineMessages<string>({
  [UserBadRequestError.PASSWORD_RESET_REQUESTED]: {
    id: 'signIn.passwordResetRequested',
    defaultMessage:
      'The owner of your clinic or a Diagnocat administrator asked you to set a new password. Reset it to sign in.',
  },
});

export const newPasswordErrorMessages = defineMessages<string>({
  [NotFoundError.TOKEN]: {
    id: 'newPassword.errors.twiceTokenError',
    defaultMessage: 'Password already set with this link.',
  },
});
